<mat-toolbar class="loren-toolbar">
    <mat-toolbar-row
            class="loren-toolbar-row"
            [ngClass]="{ 'loren-toolbar-row-mobile': isHandset }">
        <form class="loren-toolbar-search">
            <mat-form-field
                    appearance="fill"
                    class="loren-form-field loren-toolbar-search-field">
                <mat-icon matIconPrefix>search</mat-icon>
                <input
                        matInput
                        class="loren-toolbar-search-input"
                        [placeholder]="'toolbar.search_placeholder' | transloco"
                        [formControl]="searchTerm"
                />
                @let value = searchTerm$ | async;
                @if (value) {
                    <button
                            matSuffix
                            mat-icon-button
                            aria-label="Clear search"
                            (click)="clearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </mat-form-field>
        </form>
        <div class="loren-toolbar-nav">
            @if (isHandset) {
                <button
                        mat-icon-button
                        class="loren-toolbar-nav-item loren-toolbar-nav-hamburger"
                        type="button"
                        aria-label="Toggle sidenav"
                        [matTooltip]="'tooltips.show_hide_context_menu' | transloco"
                        (click)="drawer.toggle()">
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </button>
            }
            <loren-user-menu class="loren-toolbar-nav-item" [isHandset]="isHandset" />
            @if (!isHandset) {
                <mat-divider vertical class="loren-toolbar-nav-divider" />
            }
            @if ((isInAdminApp$ | async) === false) {
                <loren-notifications-button class="loren-toolbar-nav-item" [isHandset]="isHandset || isTablet"
                                            [drawer]="drawer"/>
                @if (!isHandset) {
                    <mat-divider vertical class="loren-toolbar-nav-divider"/>
                }
            }

            <loren-settings-menu class="loren-toolbar-nav-item" [isHandset]="isHandset || isTablet"/>
            @if (!isHandset) {
                <mat-divider vertical class="loren-toolbar-nav-divider"/>
            }

            <loren-help-button class="loren-toolbar-nav-item" [isHandset]="isHandset || isTablet"/>
            @if (!isHandset) {
                <mat-divider vertical class="loren-toolbar-nav-divider"/>
            }

            <loren-language-switcher class="loren-toolbar-nav-item" [isHandset]="isHandset || isTablet"/>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
